/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { transactionsCountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGet } from "../../funcs/transactionsCountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .CountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGetRequest$inboundSchema,
};

export const tool$transactionsCountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGet:
  ToolDefinition<typeof args> = {
    name: "transactions-count-v2",
    description: `Original tool name: transactions-api-v2-ledgers-ledger-canister-id-transactions-count-get

Get the total count of transactions matching the given criteria`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await transactionsCountTransactionsApiV2LedgersLedgerCanisterIdTransactionsCountGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };